<div class="header-dialog">
  <div class="titre">
    <mat-icon fontIcon="checklist"></mat-icon>
    <span>{{ 'actions.from_risk_title' | translate }}</span>
  </div>

  <lib-button (click)="close()" icon="close" color="none" textColor="muted"></lib-button>
</div>

<div class="subtitle" *ngIf="data.riskTitle">
  {{ 'actions.link_for' | translate }} <strong>{{ data.riskTitle }}</strong>
</div>

<mat-tab-group [(selectedIndex)]="selectedTab" class="action-tabs">
  <!-- Tab 1: Create -->
  <mat-tab label="{{ 'actions.tab.create' | translate }}">
    <form class="action-form" (submit)="create(); $event.preventDefault()">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{ 'actions.field.title' | translate }}</mat-label>
        <input type="text" matInput [(ngModel)]="newAction.title" name="title" required>
      </mat-form-field>

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>{{ 'actions.field.description' | translate }}</mat-label>
        <textarea matInput [(ngModel)]="newAction.description" name="description" rows="3"></textarea>
      </mat-form-field>

      <div class="form-column">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.type' | translate }}</mat-label>
          <mat-select [(ngModel)]="newAction.type" name="type">
            <mat-option *ngFor="let t of typeOptions" [value]="t">
              {{ 'actions.type.' + t | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.priority' | translate }}</mat-label>
          <mat-select [(ngModel)]="newAction.priority" name="priority">
            <mat-option *ngFor="let p of priorityOptions" [value]="p">
              {{ 'actions.priority.' + p | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.status' | translate }}</mat-label>
          <mat-select [(ngModel)]="newAction.status" name="status">
            <mat-option *ngFor="let s of statusOptions" [value]="s">
              {{ 'actions.status.' + s | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-column">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.assignee' | translate }}</mat-label>
          <mat-select [(ngModel)]="newAction.assignee" name="assignee">
            <mat-option [value]="null">{{ 'form.none' | translate }}</mat-option>
            <mat-option *ngFor="let u of users" [value]="u.id">
              {{ u.firstName }} {{ u.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.dueDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="duePicker" [(ngModel)]="newAction.dueDate" name="dueDate">
          <mat-datepicker-toggle matSuffix [for]="duePicker"></mat-datepicker-toggle>
          <mat-datepicker #duePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </form>
  </mat-tab>

  <!-- Tab 2: Link to existing -->
  <mat-tab label="{{ 'actions.tab.link' | translate }}">
    <div class="toolbar">
      <app-search-bar (searchText)="search($event)"></app-search-bar>
    </div>

    <div class="list-container">
      <ng-container *ngIf="!loadingList">
        <ng-container *ngIf="filteredActions.length; else noActions">
          <mat-radio-group [(ngModel)]="selectedId" class="actions-list">
            <label *ngFor="let a of filteredActions" class="action-row" [class.selected]="selectedId === a.id">
              <mat-radio-button [value]="a.id"></mat-radio-button>
              <div class="action-content">
                <div class="action-title">{{ a.title }}</div>
                <div class="action-meta">
                  <span class="chip chip-muted">{{ 'actions.type.' + a.type | translate }}</span>
                  <span class="chip chip-muted">{{ 'actions.status.' + a.status | translate }}</span>
                  <span class="chip chip-muted">{{ 'actions.priority.' + a.priority | translate }}</span>
                  <span *ngIf="a.dueDate" class="due-date">
                    <mat-icon fontIcon="event" class="meta-icon"></mat-icon>
                    {{ a.dueDate | timeFormat: 'dd/MM/yyyy' }}
                  </span>
                </div>
              </div>
            </label>
          </mat-radio-group>
        </ng-container>

        <ng-template #noActions>
          <lib-no-data message="actions.no_link_available" description="actions.no_link_available_desc"
            icon="search_off"></lib-no-data>
        </ng-template>
      </ng-container>

      <div *ngIf="loadingList" class="loading-overlay">
        <app-spinner></app-spinner>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>

<mat-dialog-actions class="actions">
  <lib-button (click)="close()" color="outline" icon="close" text="{{ 'viewer.close' | translate }}">
  </lib-button>

  <lib-button *ngIf="selectedTab === 0" color="primary" icon="save"
    text="{{ 'actions.create_confirm' | translate }}" (click)="create()" [loading]="saving">
  </lib-button>

  <lib-button *ngIf="selectedTab === 1" color="primary" icon="link"
    text="{{ 'actions.link_confirm' | translate }}" (click)="link()" [loading]="saving" [disabled]="!selectedId">
  </lib-button>
</mat-dialog-actions>
